'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccounts$002dPage$0024 from "./presto.-List-Accounts-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002471 from "./presto.-Presto-Router$$anon$71.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$70() {
  this.bmn = null;
  this.bmf = null;
  this.bmg = false;
  this.bmo = null;
  this.bmp = false;
  this.bms = null;
  this.bml = null;
  this.bmm = false;
  this.bmh = null;
  this.bmi = false;
  this.bmj = null;
  this.bmk = false;
  this.bmq = false;
  this.bmr = false;
  this.bmn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bms = "ListAccountsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$70 as $c_Lpresto_PrestoRouter$$anon$70 };
$p = $c_Lpresto_PrestoRouter$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$70;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$70() {
}
export { $h_Lpresto_PrestoRouter$$anon$70 as $h_Lpresto_PrestoRouter$$anon$70 };
$h_Lpresto_PrestoRouter$$anon$70.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bmn;
});
$p.L = (function() {
  if ((!this.bmg)) {
    this.bmf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmg = true;
  }
  return this.bmf;
});
$p.O = (function() {
  if ((!this.bmp)) {
    this.bmo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmp = true;
  }
  return this.bmo;
});
$p.E = (function() {
  return this.bms;
});
$p.t = (function() {
  if ((!this.bmm)) {
    this.bml = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmm = true;
  }
  return this.bml;
});
$p.M = (function() {
  if ((!this.bmi)) {
    this.bmh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmi = true;
  }
  return this.bmh;
});
$p.Q = (function() {
  if ((!this.bmk)) {
    this.bmj = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002471.$c_Lpresto_PrestoRouter$$anon$71();
    this.bmk = true;
  }
  return this.bmj;
});
$p.w = (function() {
  if ((!this.bmr)) {
    this.bmq = false;
    this.bmr = true;
  }
  return this.bmq;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee494) => ((p) => \u03b4scrutinee494))($j_presto$002e$002dList$002dAccounts$002dPage$0024.$m_Lpresto_ListAccountsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$70, "presto.PrestoRouter$$anon$70", ({
  OD: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$70 as $d_Lpresto_PrestoRouter$$anon$70 };
//# sourceMappingURL=presto.-Presto-Router$$anon$70.js.map
